<template>
  <div id="DistributionRevenueDeliveryRate">
  </div>
</template>

<script>
import common from '@/mixins/common.js'
import * as echarts from 'echarts'
import resize from './echarts/mixins/resize'
export default {
  mixins: [resize, common],
  name: 'DistributionRevenueDeliveryRate',
  components: {

  },
  props: {
    'distributedVolist': {
      type: Array,
      default: () => []
    }
  },
  created () {

  },
  data () {
    return {
      chart: null,
      chartOptions: {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '4%',
          bottom: '14%',
          top: '16%',
          containLabel: true
        },
        legend: {
          right: 0,
          itemHeight: 10,
          top: '1%',
          textStyle: {
            color: '#FFFF'
          },
          data: ['营收', '成本', '投放率']
        },
        'dataZoom': [{
          'show': true,
          'height': 22,
          'xAxisIndex': [
            0
          ],
          bottom: '8%',
          'start': 0,
          'end': 90,
          handleSize: '110%',
          handleStyle: {
            color: '#d3dee5'
          },
          textStyle: {
            color: '#fff'
          },
          borderColor: '#90979c'
        }, {
          'type': 'inside',
          'show': true,
          'height': 15,
          'start': 1,
          'end': 35
        }],
        yAxis: [
          {
            name: '万元',
            type: 'value',
            max: '0',
            interval: 0,
            axisLine: {
              show: false,
              lineStyle: {
                color: 'white'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0)'
              }
            },
            axisLabel: {}
          },
          {
            name: '百分比',
            type: 'value',
            max: 100,
            min: 0,
            interval: 10,
            axisLine: {
              show: false,
              lineStyle: {
                color: 'white'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.1)'
              }
            },
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        xAxis: {
          type: 'category',
          data: [],
          axisLine: {
            lineStyle: {
              color: 'white'
            }
          },
          axisLabel: {
            // interval: 0,
            rotate: 40,
            textStyle: {
              fontFamily: 'Microsoft YaHei'
            }
          }
        },
        series: [
          {
            name: '营收',
            type: 'bar',
            data: [200, 300],
            barGap: 0,
            color: '#1d5eeb'
          },
          {
            name: '成本',
            type: 'bar',
            data: [1200, 1300],
            color: '#edcd4b'
          },
          {
            name: '投放率',
            type: 'line',
            yAxisIndex: 1,
            data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2],
            color: '#65d5d1'
          }
        ]
      }
    }
  },
  computed: {

  },

  mounted () {
    this.initChart()
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  watch: {
    distributedVolist: {
      handler: function (newValue, oldValue) {
        if (newValue.length === 0) { return false }
        let cities = []
        let tflLists = []
        let cbLists = []
        let ysLists = []
        newValue.forEach((item) => {
          let { province, tfl, cb, ys } = item
          cities.push(province)
          tflLists.push(tfl)
          cbLists.push(this.numberSplitWithComma((cb / 10000 || 0)))
          ysLists.push(this.numberSplitWithComma((ys / 10000 || 0)))
          this.setyAxis(this.numberSplitWithComma((cb / 10000 || 0)), this.numberSplitWithComma((ys / 10000 || 0)))
        })
        this.setxAxisData(cities)
        this.setSeriesCites(tflLists, ysLists, cbLists)
        this.setChartDataOptions(this.chartOptions)
      },
      immediate: true
    }
  },
  methods: {
    initChart () {
      this.chart = echarts.init(document.getElementById('DistributionRevenueDeliveryRate'), {}, { renderer: 'svg' })
      // this.setChartDataOptions(this.chartOptions)
    },
    setChartDataOptions (option) {
      this.chart && this.chart.setOption(option)
    },
    setxAxisData (cities) {
      this.chartOptions.xAxis.data = cities
    },
    setSeriesCites (tflLists, ysLists, cbLists) {
      this.chartOptions.series[0].data = ysLists
      this.chartOptions.series[1].data = cbLists
      this.chartOptions.series[2].data = tflLists
    },
    setyAxis (cb, ys) {
      let max = Math.max(cb, ys)
      let yAxisValMax = this.chartOptions.yAxis[0].max
      this.chartOptions.yAxis[0].max = Math.ceil(+max > +yAxisValMax ? max + '' : yAxisValMax)
      this.chartOptions.yAxis[0].interval = Math.ceil(+this.chartOptions.yAxis[0].max / 10)
    }
  }
}
</script>

<style scoped lang="stylus">
#DistributionRevenueDeliveryRate
  height: 100%
</style>
